import { Component, OnInit } from '@angular/core';
import { BenefitsService } from './benefits.service';
import { CommonUtilitiesService } from '../common-utilities.service';
import { constants } from '../constants';

@Component({
  selector: 'app-benefits',
  templateUrl: './benefits.component.html',
  styleUrls: ['./benefits.component.scss']
})
export class BenefitsComponent implements OnInit {
  listBenefits = null;
  isShowModal = false;
  modalTitle = "";
  modalContent = "";
  isShowBenefits = false;

  constructor(public LANG:CommonUtilitiesService, private benefitsService: BenefitsService) { }
  /**
   * Description: Método que al cargar llama a su sericio y carga los beneficios automaticamente 
   * Autor: Steven Sterling
   * @param N/A
   * @return N/A
   */
  ngOnInit() {
    if(this.listBenefits == null || this.listBenefits == ''){
      this.benefitsService.getBenefitsList().subscribe((dataInfo => {
        if(dataInfo['responseCode'] ==  constants.SUCCESS_WS_RESPONSE_CODE){
          this.listBenefits = dataInfo['obj'];
          this.isShowBenefits = true;
        }else{
          this.modalTitle = "Error: ";
          this.modalContent =  "No se ha podido establecer la conexión con el servidor al cargar los beneficios.";
          this.isShowModal = true;
        }
  
      }),
      (err) => {
        this.modalTitle = this.LANG.getLangText('LABEL_ERROR') + err.code;
        this.modalContent =  this.LANG.getLangText('LABEL_ERROR_SERVICE_CONN');
        this.isShowModal = true;
      });
    }
  }
  formatImg(base64Img){
    return constants.BASE64_INIT + base64Img;
  }

}
